
import IndexHeader from '@/components/IndexHeader'
import IndexSidebar from '@/components/IndexSidebar'
import IndexFooter from '@/components/IndexFooter'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

const caseList = [
{imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/douyin/douyin_case01.png'},
{imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/douyin/douyin_case02.png'},
{imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/douyin/douyin_case03.png'}
]
export default {
data () {
return {
douyinTabIndex: '0',
resourceMZ: [
{
imgSrc: 'https://static.xinmeibao.com/uploads/000003/4b7a71ba37c545ca74a16b91ab623600.jpeg',
name: 'm哥',
fansNum: '2763.3W'
},
{
imgSrc: 'https://static.xinmeibao.com/uploads/000003/c76933118374a7435d0c5de3120df11f.jpeg',
name: '彭十六elf',
fansNum: '1362.2w'
},
{
imgSrc: 'https://static.xinmeibao.com/uploads/000003/031261921a2fc9427537155e5b86b48b.jpeg',
name: '乔万旭',
fansNum: '613.4w'
},
{
imgSrc: 'https://static.xinmeibao.com/uploads/000003/5f76f44de84a9eec38b5b9c826c87e5f.jpeg',
name: '张凯毅Kevin',
fansNum: '683W'
},
{
imgSrc: 'https://static.xinmeibao.com/uploads/000003/97cc77687708668a023746404d9ddc96.jpeg',
name: '认真少女_颜九',
fansNum: '523.8W'
},
{
imgSrc: 'https://static.xinmeibao.com/uploads/000003/d853ee81d6bbde5f34a8f8f71b587724.jpeg',
name: '谷大喵',
fansNum: '298.3W'
}
],
resourceCar: [
{
imgSrc: 'https://static.xinmeibao.com/uploads/000003/bcaed98ce5f47636986983cb3665cb95.jpeg',
name: '车老湿',
fansNum: '51.1W'
},
{
imgSrc: 'https://static.xinmeibao.com/uploads/000003/633472ad735baccb656fbe17eae851f6.jpeg',
name: '疯狂特效师',
fansNum: '202.5W'
},
{
imgSrc: 'https://static.xinmeibao.com/uploads/000003/031261921a2fc9427537155e5b86b48b.jpeg',
name: '车圈女神美丽姐',
fansNum: '123.7W'
},
{
imgSrc: 'https://static.xinmeibao.com/uploads/000003/27445ab166b9c68882db3f773277675a.jpg',
name: '*^_^*爱闪亮*^',
fansNum: '120.9W'
},
{
imgSrc: 'https://static.xinmeibao.com/uploads/000003/b6f865cb2a4e810e55305a44a330aa16.jpeg',
name: '王乙清',
fansNum: '80.9W'
},
{
imgSrc: 'https://static.xinmeibao.com/uploads/000003/d21eeb73a3bee29b016e8b643bca99b7.jpeg',
name: '=-张越',
fansNum: '153.6W'
}
],
resourceFahion: [
{
imgSrc: 'https://static.xinmeibao.com/uploads/000003/f89df74090a61adec0fd4f0319bf0273.jpeg',
name: '绝世的容颜',
fansNum: '253.3W'
},
{
imgSrc: 'https://static.xinmeibao.com/uploads/000003/b3005da03a102a3bdbe679fccd947d6c.jpeg',
name: '霹雳无敌璟儿',
fansNum: '149.8W'
},
{
imgSrc: 'https://static.xinmeibao.com/uploads/000003/965d77f14410beab30c8fc228d731ba8.jpeg',
name: 'Tender黄梦',
fansNum: '400.4W'
},
{
imgSrc: 'https://static.xinmeibao.com/uploads/000003/8775f0cb9d5956177650a11a6f78e34c.jpg',
name: '线条君LineDancer',
fansNum: '392.5W'
},
{
imgSrc: 'https://static.xinmeibao.com/uploads/000003/a2fe0e4cbb4bbb864ee2f1738a8ef0a9.jpeg',
name: '小不忍则卖大萌哥',
fansNum: '175.5W'
},
{
imgSrc: 'https://static.xinmeibao.com/uploads/000003/a67bc9510516205d436b3c0a9bdec831.jpeg',
name: 'I\'m～Ming周智明',
fansNum: '209.8W'
}
],
caseList: caseList,
caseIndex: 0
}
},
components: {
IndexHeader,
IndexSidebar,
IndexFooter,
Swiper,
SwiperItem
},
methods: {
changeDouyinTab (index) {
this.douyinTabIndex = index
},
caseIndexChange (index) {
this.caseIndex = index
}
}
}



// WEBPACK FOOTER //
// ./src/pages/promotionDouyin/index.vue